import { render, staticRenderFns } from "./DeptCalendarWebpart.vue?vue&type=template&id=31530289&scoped=true"
import script from "./DeptCalendarWebpart.ts?vue&type=script&lang=ts&external"
export * from "./DeptCalendarWebpart.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31530289",
  null
  
)

export default component.exports